import {Col, Collapse, Modal, notification, Pagination, Row, Table, Tag} from "antd";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {GammaProductBaseDto, ProductBaseDto, ProductService, VariantBaseDto, VariantService,} from "../../../api";
import {AvailableFilters, ButtonFilter} from "../../../Components/ButtonFilter";
import {Paged} from "../../../utils/pagedResponse";
import {toIncludes} from "../../../utils/request";
import {RowTable} from "./RowTable";
import ProductVariantModal, {VariantData} from "../../../Components/products/ProductVariantModal";
import ProductMediaModal, {ProductMediaData} from "../../../Components/products/ProductMediaModal";
import {DEFAULT_FALLBACK} from "../../../App";
import {CameraFilled} from "@ant-design/icons";

export const Products = () => {
  const [showEditVariantModal, setShowEditVariantModal] = useState(false);
  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [products, setProducts] = useState<Paged<ProductBaseDto>>();
  const [meta, setMeta] = useState<any>();
  const [selectedVariant, setSelectedVariant] = useState<VariantBaseDto>();
  const [selectedProduct, setselectedProduct] = useState<ProductBaseDto>();
  const [pagination, setPagination] = useState();
  const [pages, setPages] = useState([0, 10]);
  const {t} = useTranslation();
  const [filters, setFilters] = useState<AvailableFilters>()
  const [imageRefreshKey, setImageRefreshKey] = useState(0);
  const [isSyncLoading, setIsSyncLoading] = useState(false);
  const [syncResult, setSyncResult] = useState<{
    updatedProducts?: Array<GammaProductBaseDto>;
    updatedStocks?: Array<{itemCode?: string; itemCodeVariant?: string; availability?: number}>;
  } | null>(null);
  const [api, contextHolder] = notification.useNotification();

  const [price, setPrice] = useState({
    price: {
      $gte: 0,
      $lte: 0,
    },
  });

  useEffect(() => {
    // getAllProducts();
    findProductsWithFilters(filters)
  }, [pages]);

  useEffect(() => {
    // getAllProducts();
    findProductsWithFilters(filters)
  }, [filters]);

  const columns = [
    t("common.article"),
    t("common.brand"),
    t("common.color"),
    t("common.size"),
    t("common.€net"),
    t("common.stock"),
    // t("common.packages"),
    t("common.returnDate"),
    t("common.edit"),
    // t('common.delete'),
  ];

  const findProductsWithFilters = (variantsFilters?: any) => {
    if (variantsFilters)
      variantsFilters.isVisible = true
    else variantsFilters = { isVisible: true };
    ProductService.findAllProductController(
      pages[0],
      pages[1],
      JSON.stringify(variantsFilters),
      undefined,
      undefined,
      toIncludes<ProductBaseDto>({
        variants: {
          media: true,
        },
        media: true,
        categories: {
          category: {
            father: true,
          },
        },
      })
    ).then((res) => {
      setMeta(res.meta)
      if (pages[0] >= 1 && products) {
        setProducts({
          ...res
        });
      } else {
        setProducts(res);
      }
    });
  };

  const updateProductMedia = async (data: ProductMediaData) => {
    if (!selectedProduct) return;
    try {
      if (data.deleteImage) {
        await ProductService.deleteMediaProductController(selectedProduct.id!);
      } else if (data.image && typeof data.image === "object") {
        await ProductService.setMediaProductController(selectedProduct.id!, {file: data.image});
      }
      api.success({message: t("dashboard.products.variantUpdateSuccess")});
      findProductsWithFilters(filters);
    } catch (error) {
      api.error({message: t("dashboard.products.variantUpdateError")});
    } finally {
      setShowEditProductModal(false);
    }
  };

  const handleSyncGamma = async () => {
    if (!selectedProduct) return;
    setIsSyncLoading(true);
    try {
      const result = await ProductService.syncGammaProductProductController(selectedProduct.id!);
      setSyncResult(result);
      api.success({message: "Prodotto sincronizzato con Gamma"});
      findProductsWithFilters(filters);
    } catch (error) {
      api.error({message: "Errore durante la sincronizzazione con Gamma"});
    } finally {
      setIsSyncLoading(false);
    }
  };

  const handleVariantUploadMedia = async (variantId: number, file: File) => {
    try {
      await VariantService.setMediaVariantController(variantId, {file});
      api.success({message: t("dashboard.products.variantUpdateSuccess")});
      findProductsWithFilters(filters);
    } catch (error) {
      api.error({message: t("dashboard.products.variantUpdateError")});
    }
  };

  const handleVariantDeleteMedia = async (variantId: number) => {
    try {
      await VariantService.deleteMediaVariantController(variantId);
      api.success({message: t("dashboard.products.variantUpdateSuccess")});
      findProductsWithFilters(filters);
    } catch (error) {
      api.error({message: t("dashboard.products.variantUpdateError")});
    }
  };

  const updateVariant = async (updatedData: VariantData) => {
    if (!selectedVariant) return;

    try {
      await VariantService.updateVariantController(
        selectedVariant.id!,
        {
          size: updatedData.size,
          colors: updatedData.colors,
          isVisible: updatedData.isVisible
        }
      );

      if (updatedData.image && typeof updatedData.image === "object") await VariantService.setMediaVariantController(
        selectedVariant.id!,
        {
          file: updatedData.image
        }
      )

      api.success({message: t("dashboard.products.variantUpdateSuccess")});
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.log("updateVariant", error);
      api.error({message: t("dashboard.products.variantUpdateError")});
    } finally {
      setShowEditVariantModal(false);
    }
  }

  return (
    <div>
      <div className="text-[#333843] text-base font-semibold leading-6 mb-4">
        {t("common.products")}
      </div>
      <div
        style={{
          borderRadius: "8px",
          border: " 1px solid var(--neutral-gray-gray-100, #E0E2E7)",
          background: "var(--neutral-white, #FFF)",
          boxShadow: "0px 1.5px 2px 0px rgba(16, 24, 40, 0.10)",
          height: "100%",
        }}
      >
        <div className="p-4">
          <ButtonFilter
            showButton={true}
            show={
              {code: true, description: true, price: true, brand: true}
            }
            meta={meta}
            showSelectedFilters={true}
            findProducts={(v) => {
              setFilters(v);
              // findProductsWithFilters(v)
            }}
            findProductsWithFilters={(v: any) => {
              findProductsWithFilters(v);
            }}
          ></ButtonFilter>
        </div>
        <Row className="bg-neutral-100">
          {columns.map((res, index) => {
            return (
              <Col
                key={res}
                className="border-b border-b-[#F0F1F3] text-[#002655] text-xs font-semibold pb-[18px] pt-[18px] text-center"
                span={index === 4 ? 4 : 2}
              >
                {res}
              </Col>
            );
          })}
          <div className="w-full">
            {products?.data.map((product) => {
              return (
                <Collapse
                  key={product.id}
                  className="w-full"
                  expandIconPosition="end"
                  bordered={false}
                  onChange={() => console.log("prod", product)}
                  items={[
                    {
                      key: product.id,
                      label: (
                        <div>
                          <Row>
                            <Col xl={1} md={2}>
                              <div
                                className="relative w-8 h-8 rounded-lg group cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setselectedProduct(product);
                                  setShowEditProductModal(true);
                                }}
                                style={{
                                  backgroundImage: `url(${encodeURI(product.media?.path ?? product?.variants[0]?.media?.path)}?v=${imageRefreshKey}), url(${DEFAULT_FALLBACK})`,

                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              >
                                <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition rounded-lg">
                                  <CameraFilled className="text-white text-xs"/>
                                </div>
                              </div>
                            </Col>
                            <Col xl={21} md={20}>
                              <div
                                className="text-xs text-[#2A2E34] font-bold leading-[18px] tracking-[0.06px] capitalize h-full items-center">
                                {product?.name.toLocaleLowerCase()} <br/>
                                {product?.code}
                              </div>
                            </Col>

                            <Col xl={1} md={1} className="flex">
                              <span
                                className="text-[#888] text-[12px] underline cursor-pointer -ml-4"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setselectedProduct(product);
                                  setShowEditProductModal(true);
                                }}
                              >
                                {t("common.edit")}
                              </span>
                            </Col>

                            <Col xl={1} md={1} className="capitalize">
                              {product?.categories[0]?.category?.name?.toLocaleLowerCase()}
                            </Col>
                          </Row>{" "}
                        </div>
                      ),
                      children: (
                        <>
                          {" "}
                          {product?.variants?.map((variant, index) => {
                            return (
                              <div key={variant.id}>
                                <RowTable
                                  index={index}
                                  arrayLength={product?.variants.length}
                                  // deleteVariant={(variantValue) => {
                                  //   VariantService.deleteVariantController(
                                  //     variantValue?.id ? variantValue.id : 0
                                  //   ).then(() => {
                                  //     setIsModalOpen(false);
                                  //     notificationSuccess();
                                  //   });
                                  // }}
                                  variant={variant}
                                  brand={product?.brand?.name}
                                  onUploadMedia={(variantId, file) => handleVariantUploadMedia(variantId, file)}
                                  onDeleteMedia={(variantId) => handleVariantDeleteMedia(variantId)}
                                  edit={(variantValue) => {
                                    setSelectedVariant(variantValue);
                                    setselectedProduct(product);
                                    setShowEditVariantModal(true);
                                  }}
                                ></RowTable>
                              </div>
                            );
                          })}
                        </>
                      ),
                    },
                  ]}
                ></Collapse>
              );
            })}
          </div>
        </Row>
        <div className="flex justify-center p-4">
          <Pagination
            responsive={true}
            defaultCurrent={pages[0] + 1}
            pageSize={pages[1]}
            onChange={(page, pageSize) => {
              setPages([page - 1, pages[1]]);
              if (pageSize) {
                setPages([page - 1, pageSize]);
              }
            }}
            total={products?.totalCount}
          />
        </div>
      </div>

      <ProductVariantModal product={selectedProduct} variant={selectedVariant} isOpen={showEditVariantModal}
                           onConfirm={updateVariant} onCancel={() => setShowEditVariantModal(false)}/>
      <ProductMediaModal product={selectedProduct} isOpen={showEditProductModal}
                         onConfirm={updateProductMedia} onSyncGamma={handleSyncGamma} isSyncLoading={isSyncLoading} onCancel={() => setShowEditProductModal(false)}/>

      <Modal
        title={<span className="text-[#0950A8] font-semibold">Riepilogo sincronizzazione Gamma</span>}
        open={!!syncResult}
        onCancel={() => setSyncResult(null)}
        onOk={() => setSyncResult(null)}
        width={700}
      >
        {syncResult && (
          <div className="flex flex-col gap-4">
            <div>
              <div className="text-blue-400 text-sm font-semibold mb-2">
                Varianti aggiornate ({syncResult.updatedProducts?.length ?? 0})
              </div>
              <Table
                size="small"
                dataSource={syncResult.updatedProducts ?? []}
                rowKey={(r) => `${r.itemCode}-${r.variant}`}
                pagination={false}
                scroll={{y: 200}}
                columns={[
                  {title: "Codice", dataIndex: "itemCode", key: "itemCode", width: 100},
                  {title: "Variante", dataIndex: "variant", key: "variant", width: 80},
                  {title: "Descrizione", dataIndex: "itemDescription", key: "itemDescription", ellipsis: true},
                  {title: "P1 netto", dataIndex: "netPriceList1", key: "netPriceList1", width: 90, render: (v: number) => v != null ? `€ ${v}` : "-"},
                  {title: "P2 netto", dataIndex: "netPriceList2", key: "netPriceList2", width: 90, render: (v: number) => v != null ? `€ ${v}` : "-"},
                  {title: "P3 netto", dataIndex: "netPriceList3", key: "netPriceList3", width: 90, render: (v: number) => v != null ? `€ ${v}` : "-"},
                ]}
              />
            </div>
            <div>
              <div className="text-blue-400 text-sm font-semibold mb-2">
                Stock aggiornati ({syncResult.updatedStocks?.length ?? 0})
              </div>
              <Table
                size="small"
                dataSource={syncResult.updatedStocks ?? []}
                rowKey={(r) => `${r.itemCode}-${r.itemCodeVariant}`}
                pagination={false}
                scroll={{y: 200}}
                columns={[
                  {title: "Codice", dataIndex: "itemCode", key: "itemCode", width: 120},
                  {title: "Variante", dataIndex: "itemCodeVariant", key: "itemCodeVariant", width: 120},
                  {title: "Disponibilità", dataIndex: "availability", key: "availability", render: (v: number) => (
                    <Tag color={v > 0 ? "green" : "red"}>{v ?? 0}</Tag>
                  )},
                ]}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};
